import { sanitizeOrganizationId } from '@core/configuration';
import { OrganizationLocalStorage } from './OrganizationLocalStorage.js';
import { OrganizationSelectors } from './selectors/OrganizationSelectors.js';
import { OrganizationStore } from './store/OrganizationStore.js';
var EXTRACT_ORG_ID_FROM_URL_HASH = /#\/(\w+)/;
var getId = function getId() {
    var _EXTRACT_ORG_ID_FROM_URL_HASH_exec;
    return OrganizationSelectors.getOrganizationId(OrganizationStore.getState()) || sanitizeOrganizationId((_EXTRACT_ORG_ID_FROM_URL_HASH_exec = EXTRACT_ORG_ID_FROM_URL_HASH.exec(window.location.hash)) === null || _EXTRACT_ORG_ID_FROM_URL_HASH_exec === void 0 ? void 0 : _EXTRACT_ORG_ID_FROM_URL_HASH_exec[1]) || OrganizationLocalStorage.getOrganizationFromLocalStorage() || null;
};
export var CurrentOrganization = {
    getId: getId
};

//# sourceMappingURL=CurrentOrganization.js.map